import React from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { ShieldCheck, Star, ThumbsUp } from 'lucide-react';
import { Button } from './ui/Button';
export function Hero() {
  const {
    scrollY
  } = useScroll();
  const y = useTransform(scrollY, [0, 500], [0, 150]);
  const scrollToQuote = () => {
    document.getElementById('quote')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const scrollToServices = () => {
    document.getElementById('services')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden pt-20 pb-16 md:pb-24" data-id="element-84">
      {/* Parallax Background */}
      <motion.div style={{
      y
    }} className="absolute inset-0 z-0" data-id="element-85">
        <div className="absolute inset-0 bg-primary/90 mix-blend-multiply z-10" data-id="element-86" />
        <div className="absolute inset-0 bg-black/20 z-10" data-id="element-87" />
        <img src="https://cdn.magicpatterns.com/uploads/e2QUgKkV2qYkjnyxun2b4W/kostiantyn-trundaiev-AIljyZlF5ZE-unsplash.jpg" alt="Pressure washing in action at night" className="w-full h-full object-cover" data-id="element-88" />
      </motion.div>

      <div className="container relative z-20 px-4 md:px-6 mx-auto flex flex-col items-center text-center mt-12 md:mt-0" data-id="element-89">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="max-w-4xl mx-auto" data-id="element-90">
          <h1 className="font-heading text-5xl md:text-7xl lg:text-8xl font-bold text-white mb-6 leading-tight uppercase tracking-tight" data-id="element-91">
            Spotless. <span className="text-accent" data-id="element-92">Every Time.</span>
          </h1>
          <p className="text-lg md:text-xl lg:text-2xl text-white/90 mb-10 max-w-2xl mx-auto font-medium" data-id="element-93">
            Professional pressure washing for driveways, roofs, siding, and
            more. Fast turnaround, guaranteed results.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 w-full sm:w-auto" data-id="element-94">
            <Button onClick={scrollToQuote} size="lg" className="bg-accent hover:bg-accent/90 text-white font-bold text-lg h-14 px-8 w-full sm:w-auto" data-id="element-95">
              Get a Free Quote
            </Button>
            <Button onClick={scrollToServices} size="lg" className="bg-white text-primary hover:bg-white/90 font-bold text-lg h-14 px-8 w-full sm:w-auto" data-id="element-96">
              See Our Work
            </Button>
          </div>
        </motion.div>

        {/* Trust Bar */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mt-16 md:mt-24 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-12 w-full max-w-4xl border-t border-white/20 pt-8" data-id="element-97">
          <div className="flex items-center justify-center gap-3 text-white" data-id="element-98">
            <ThumbsUp className="w-6 h-6 text-accent" data-id="element-99" />
            <span className="font-bold text-lg" data-id="element-100">500+ Properties Cleaned</span>
          </div>
          <div className="flex items-center justify-center gap-3 text-white" data-id="element-101">
            <Star className="w-6 h-6 text-accent fill-accent" data-id="element-102" />
            <span className="font-bold text-lg" data-id="element-103">5-Star Rated</span>
          </div>
          <div className="flex items-center justify-center gap-3 text-white" data-id="element-104">
            <ShieldCheck className="w-6 h-6 text-accent" data-id="element-105" />
            <span className="font-bold text-lg" data-id="element-106">Licensed & Insured</span>
          </div>
        </motion.div>
      </div>
    </section>;
}